export default "__VITE_ASSET__84f5b2b8__"